import {createI18n} from 'vue-i18n';

const messages = {
    en: {
        language: "Language",
        welcome: 'Welcome',
        tokenIntroduction: 'Token Introduction',
        rwa: 'RWA',
        roadmap: 'Roadmap',
        partners: 'Partners',
        mint: 'Mint',
        whatsBGIN: "What’s $BGIN?",
        bginDescription: "$BGIN is the first community-powered meme coin on the Kaspa blockchain. We’re not just about laughs—we’re here to bridge Real-World Assets (RWAs) into the DeFi space. Mining power, electricity, intellectual property, and more are about to get tokenized.",
        eligibilityCheck: 'Eligibility check Starts in',
        mintKSPR: 'Mint $BGIN on KSPR Bot',
        mintKnot: 'Mint $BGIN on Knot.meme',
        Welcometo$BGIN: "Welcome to $BGIN",
        whyBGIN: 'Why $BGIN?',
        communityDriven: 'Community-Driven',
        buildingFuture: 'We’re building the future together',
        kaspaBlockchain: 'Kaspa Blockchain',
        fastestPoW: 'The fastest PoW network on the planet',
        rwaTokenization: 'RWA Tokenization',
        realStuff: 'Real stuff, now on-chain',
        memesImpact: 'Memes + Real World Impact',
        seriousStuff: 'Serious stuff... with a side of fun',
        bginToken: '$BGIN Token – More Than Just an IDEA',
        governanceToken: 'Governance Token',
        shapeFuture: 'You hold $BGIN? You get to help shape the future',
        fairLaunch: 'Fair Launch',
        noPreMining: 'No pre-mining, no funny business, just community',
        billionTokens: '1 Billion Tokens',
        getYours: 'Get yours while you can',
        krc20: 'The Token Standard of the Future',
        krc20Description: 'KRC-20 brings you the power of Kaspa—fast transactions, low fees, and endless possibilities. Build, mint, and trade without the hassle.',
        roadmapTitle: 'Roadmap',
        bginJourney: 'The $BGIN Journey',
        phase1: 'Phase 1:',
        phase1_1: 'Launch',
        phase1Desc: 'Mint, community building, Airdrop.',
        phase2: 'Phase 2:',
        phase2_1: 'Tokenization',
        phase2Desc: 'Real-world stuff goes on-chain.',
        phase3: 'Phase 3:',
        phase3_1: 'Smart Contracts',
        phase3Desc: 'Full DeFi integration.',
        phase4: 'Phase 4:',
        phase4_1: 'Adoption',
        phase4Desc: 'Game time. The $BGIN revolution is happening.',
        getIn: 'Get In, Get $BGIN',
        joinCommunity: 'Join the community',
        innovationFinance: '+ innovation + real-world finance = $BGIN',
        noFOMO: 'No FOMO',
        revolutionStarting: 'The revolution is just starting',
        secureTokens: 'Secure Your Tokens',
        bginReady: "$BGIN’s ready to moon",
        bginCoin: "$BGIN is connecting traditional assets with the innovative world of tokenization.",
        getInBgin: "Get In. Get $BGIN. Let's do this.",
        FollowUsonTwitter: "Follow Us on Twitter",
        FollowUsonTelegram: "Follow Us on Telegram",
        Disclaimer: "Disclaimer：$BGIN Token is not affiliated with Bgin Blockchain. We are simply inspired by their ideas, but this token is not associated with their projects in any way.",
        MoreThan: 'More Than Just an IDEA',
    },
    ru: {
        language: "Язык",
        welcome: 'Добро пожаловать',
        tokenIntroduction: 'Введение в токен',
        rwa: 'RWA',
        roadmap: 'Дорожная карта',
        partners: 'Партнеры',
        mint: 'Минтинг',
        WelcometoBGIN: " Добро пожаловать в $BGIN",
        whatsBGIN: "Что такое $BGIN?",
        bginDescription: "$BGIN — это первый токен, поддерживаемый сообществом, на блокчейне Kaspa. Мы не только для веселья — мы здесь, чтобы перенести реальные активы (RWA) в пространство DeFi. Энергия майнинга, электричество, интеллектуальная собственность и многое другое скоро будут токенизированы.",
        eligibilityCheck: 'Проверка прав на участие начинается через',
        mintKSPR: 'Минтить $BGIN на KSPR Bot',
        mintKnot: 'Минтить $BGIN на Knot.meme',
        whyBGIN: 'Почему $BGIN?',
        communityDriven: 'Сообщественно-ориентированность',
        buildingFuture: 'Мы строим будущее вместе',
        kaspaBlockchain: 'Блокчейн Kaspa',
        fastestPoW: 'Самая быстрая PoW-сеть на планете',
        rwaTokenization: 'Токенизация RWA',
        realStuff: 'Реальные вещи теперь в блокчейне',
        memesImpact: 'Мемы + реальное влияние',
        seriousStuff: 'Серьезные дела... с капелькой веселья',
        bginToken: '$BGIN Token — это больше, чем просто идея',
        governanceToken: 'Голосующий токен',
        shapeFuture: 'У тебя есть $BGIN? Ты можешь помочь формировать будущее',
        fairLaunch: 'Честный запуск',
        noPreMining: 'Без пре-минтинга, только сообщество',
        billionTokens: '1 миллиард токенов',
        getYours: 'Получите свои пока можете',
        krc20: 'Токен стандарта будущего',
        krc20Description: 'KRC-20 дает вам всю мощь Kaspa — быстрые транзакции, низкие комиссии и бесконечные возможности. Строить, минтить и торговать без хлопот.',
        roadmapTitle: 'Дорожная карта',
        bginJourney: 'Путь $BGIN',
        phase1: 'Этап 1: ',
        phase1_1: 'Запуск',
        phase1Desc: 'Минтинг, построение сообщества, аирдроп.',
        phase2: 'Этап 2: ',
        phase2_1: 'Токенизация',
        phase2Desc: 'Реальные активы переходят на блокчейн.',
        phase3: 'Этап 3: ',
        phase3_1: 'Умные контракты',
        phase3Desc: 'Полная интеграция в DeFi.',
        phase4: 'Этап 4: ',
        phase4_1: 'Принятие',
        phase4Desc: 'Время игр. Революция $BGIN начинается.',
        getIn: 'Присоединяйтесь, получите $BGIN',
        joinCommunity: 'Присоединяйтесь к сообществу',
        innovationFinance: '+ инновации + реальные финансы = $BGIN',
        noFOMO: 'Не пропустите',
        revolutionStarting: 'Это только начало',
        secureTokens: 'Защитите свои токены',
        bginReady: "$BGIN готовится к взлету",
        bginCoin: "$BGIN соединяет традиционные активы с инновационным миром токенизации.",
        getInBgin: "Присоединяйтесь. Получите $BGIN. Давайте сделаем это.",
        FollowUsonTwitter: "Подписывайтесь на нас в Twitter",
        FollowUsonTelegram: "Подписывайтесь на нас в Telegram",
        Disclaimer: "Отказ от ответственности: $BGIN Token не связан с Bgin Blockchain. Мы просто вдохновлены их идеями, но этот токен не имеет никакого отношения к их проектам.",
        MoreThan: 'это больше, чем просто идея',
    },
    tr: {
        language: "Türkc",
        welcome: '$BGIN\'e Hoş Geldiniz',
        tokenIntroduction: 'Topluluk Tabanlı Token',
        rwa: 'RWA',
        roadmap: 'Yol Haritası',
        partners: 'Ortaklar',
        mint: 'Mint',
        WelcometoBGIN: "$BGIN'e Hosgeldiniz",
        whatsBGIN: '$BGIN Nedir?',
        bginDescription: '$BGIN, Kaspa blockchain\'inde güçlenen ilk topluluk tabanlı coin\'dir. Sadece güldürmekle kalmıyoruz—Gerçek Dünya Varlıkları\'nı (RWAs) DeFi alanına taşıyoruz. Madencilik gücü, elektrik, fikri mülkiyet ve daha fazlası token haline geliyor.',
        eligibilityCheck: 'Uygunluk kontrolü başlıyor',
        mintKSPR: 'KSPR Bot\'ta $BGIN Mintle',
        mintKnot: 'Knot.meme\'de $BGIN Mintle',
        whyBGIN: 'Neden $BGIN?',
        communityDriven: 'Topluluk Tabanlı',
        buildingFuture: 'Geleceği birlikte inşa ediyoruz',
        kaspaBlockchain: 'Kaspa Blockchain',
        fastestPoW: 'Dünyanın en hızlı PoW ağı',
        rwaTokenization: 'RWA Tokenizasyonu',
        realStuff: 'Gerçek varlıklar, artık zincirde',
        memesImpact: 'Meme + Gerçek Dünya Etkisi',
        seriousStuff: 'Ciddi işler... biraz eğlenceli şekilde',
        bginToken: '$BGIN Token – Sadece Bir Fikirden Fazlası',
        governanceToken: 'Yönetim Token\'ı',
        shapeFuture: '$BGIN tutuyorsanız, geleceği şekillendirmeye yardımcı olabilirsiniz',
        fairLaunch: 'Adil Başlangıç',
        noPreMining: 'Önceden mint yok, sadece topluluk.',
        billionTokens: '1 Milyar Token',
        getYours: 'Hemen alın, kaçırmayın',
        krc20: 'Geleceğin Token Standardı',
        krc20Description: 'KRC-20, Kaspa\'nın gücünü size getiriyor—hızlı işlemler, düşük ücretler ve sonsuz olanaklar. İnşa edin, mintleyin ve takas yapın, zahmetli işlemlerle uğraşmadan.',
        roadmapTitle: 'Yol Haritası',
        bginJourney: '$BGIN Yolculuğu',
        phase1: 'Faz 1:',
        phase1_1: 'Başlangıç',
        phase1Desc: 'Mint, topluluk oluşturma, Airdrop.',
        phase2: 'Faz 2: ',
        phase2_1: 'Tokenizasyon',
        phase2Desc: 'Gerçek dünya varlıkları zincire taşınıyor.',
        phase3: 'Faz 3: ',
        phase3_1: 'Akıllı Kontratlar',
        phase3Desc: 'Tam DeFi entegrasyonu.',
        phase4: 'Faz 4: ',
        phase4_1: 'Benimsenme',
        phase4Desc: 'Oyun zamanı. $BGIN devrimi başlıyor.',
        getIn: 'Katılın, $BGIN Alın',
        joinCommunity: 'Topluluğa katılın',
        innovationFinance: '+ yenilik + gerçek dünya finansmanı = $BGIN',
        noFOMO: 'FOMO yok',
        revolutionStarting: 'Devrim daha yeni başlıyor',
        secureTokens: 'Token\'larınızı güvence altına alın',
        bginReady: '$BGIN aya doğru gidiyor',
        bginCoin: '$BGIN, geleneksel varlıkları tokenizasyonun yenilikçi dünyasıyla birleştiriyor.',
        getInBgin: 'Hemen $BGIN satın al!',
        FollowUsonTwitter: "Bizi Twitter'da takip edin",
        FollowUsonTelegram: "Bizi Telegram'da takip edin",
        Disclaimer: "Açıklama: $BGIN Token, Bgin Blockchain ile herhangi bir ilişkiye sahip değildir. Sadece onların fikirlerinden ilham aldık, ancak bu token, projeleriyle hiçbir şekilde bağlantılı değildir.",
        MoreThan: 'Sadece Bir Fikirden Fazlası',
    }
};

const i18n = createI18n({
    locale: 'en', // 设置默认语言
    messages,
});

export default i18n;